import heroDuck from "../media/hero-duck-alt.png";
import pumpIcon from "../media/pump.svg";
import xIcon from "../media/x-alt.png";
import telegramIcon from "../media/telegram-alt.png";

function Hero() {
    return (
        <section className="hero">

            <div className="container">

                <div className="row align-items-center">

                    <div className="col-lg-5">

                        <div className="hero-image">

                            <img src={heroDuck} alt="Tube Duck" />

                        </div>

                    </div>

                    <div className="col-lg-7">

                        <div className="hero-content">

                            <h1>
                                THE
                                <br />
                                CALMEST DUCK
                                <br />
                                ON SOLANA.
                            </h1>

                            <p>
                                No panic.
                                <br />
                                Just quack.
                            </p>

                            <a
                                href="https://jup.ag/?sell=So11111111111111111111111111111111111111112&buy=GvgpSZJm2veVCLhWdwYVu3WSSVAXqyt6YcvWkyakpump"
                                target="_blank"
                                rel="noreferrer"
                                className="hero-buy-btn"
                            >
                                <img src={pumpIcon} alt="" />
                                BUY TUBE
                            </a>

                            <div className="hero-social">

                                <a
                                    href="https://x.com/Sirtube_sol"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="hero-social-btn"
                                >
                                    <img src={xIcon} alt="" />
                                    FOLLOW ON X
                                </a>

                                <a
                                    href="https://t.me/SIrTube"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="hero-social-btn"
                                >
                                    <img src={telegramIcon} alt="" />
                                    JOIN TELEGRAM
                                </a>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </section>
    );
}

export default Hero;